import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { isUserRecruiter } from 'shared-utils';
import { useUserContext } from './UserProvider';
import { Helmet } from 'react-helmet';
import { isRecruiterSide } from 'src/config/env.config';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material';

export const ThemeContext = createContext<ThemeOptions>({
	themeMode: 'dark',
	setThemeMode: () => {},
});

interface ThemeProps {
	children: React.ReactNode;
}

interface ThemeOptions {
	themeMode: string;
	setThemeMode: (val: 'dark' | 'light') => void;
}

const checkUserTheme = () => {
	return window.localStorage.getItem('theme')
		? JSON.parse(window.localStorage.getItem('theme') || '')
		: window.matchMedia('(prefers-color-scheme: dark)').matches
		  ? 'dark'
		  : 'light';
};

const ThemeProvider = ({ children }: ThemeProps) => {
	const [themeMode, setThemeMode] = useState<'dark' | 'light'>(isRecruiterSide ? 'light' : checkUserTheme());
	const { user } = useUserContext();

	// Update the theme only if the mode changes
	const theme = React.useMemo(() => createTheme({ palette: { mode: themeMode } }), [themeMode]);

	useEffect(() => {
		setThemeMode('light');
		// const queryParams = new URLSearchParams(window.location.search);
		// const lightThemeProfile = user
		// 	? isUserRecruiter(user?.role) &&
		// 	  queryParams.get('company') === 'true' &&
		// 	  window.location?.href?.includes('profile')
		// 	: queryParams.get('company') === 'true' && window.location?.href?.includes('profile');

		// if ((user?.role && isUserRecruiter(user?.role)) || isRecruiterSide || lightThemeProfile) {
		// 	setThemeMode('light');
		// 	window.localStorage.setItem('theme', JSON.stringify('light') || '');
		// } else {
		// 	setThemeMode(checkUserTheme());
		// }
	}, [user, themeMode]);

	return (
		<>
			<MuiThemeProvider theme={theme}>
				<ThemeContext.Provider value={{ themeMode, setThemeMode }}>
					<Helmet>
						<html lang="en" data-mode={themeMode} />
					</Helmet>

					{children}
				</ThemeContext.Provider>
			</MuiThemeProvider>
		</>
	);
};

export default ThemeProvider;

export const useThemeContext = () => {
	const themeContext = useContext(ThemeContext);
	return themeContext;
};
